"use client"
import { ContextData, _googleAddressSetup, _scrollToUp } from "@/services/Methods/normalMethods";
import _ from "lodash";
import { useContext, useEffect, useState } from "react";
import { _checkoutAddressFormat } from "@/services/Methods/checkoutPayloads";
import localStorageCall from "@/services/Methods/localstorage.hook";
import { _setTimeOut } from "@/services/Methods/normalMethods";
import { InitialValues, _IBOformDefaultFormat } from "@/services/Methods/validationSchema";
import { getCustomerRefferal } from "@/services/Redux/Reducer/CustomerSlice";
import { getAllCustomerData } from "@/services/Redux/Reducer/LoginSlice";
import { useDispatch } from "react-redux";

function withFormHOC(Component) {

    const ComponentWithFormProp = (props) => {
        const dispatch = useDispatch();
        const { activeStep, setActiveStep } = props;
        const { userData } = useContext(ContextData);
        let Dates = _.pick(userData, ['distributorDate', 'signUpDate', 'entryDate']);

        const [formData, setFormData] = useState(InitialValues);
        const [otp, setOtp] = useState(new Array(6).fill(""));
        const [countryState, setCountryState] = useState({
            country: "",
            state: "",
            countryError: "",
            stateError: "",
        });
        const [webAliesError, setWebAliesErros] = useState({
            changeRefferal: false,
            isRefferalError: "",
            isRefferalValid: false,
            isRefferalId: null,
        });
        useEffect(() => {
            const REFFERAL = localStorageCall().getItem('refferal_link');
            // console.log("REFFERAL", REFFERAL);
            // if (!REFFERAL?.id) {
            //     window.location.assign(`/${storeAssigned()}/signup`)
            // }
        }, [])

        const [emailExistError, setEmailExistError] = useState();

        function _handleSetFormValues(values, callback) {
            if (countryState?.country && countryState?.state) {
                const CHANGED_DATA = {
                    ...values, country: countryState?.country, state: countryState?.state,
                    ...Dates,
                }
                setFormData(CHANGED_DATA);
                callback(CHANGED_DATA);
            } else {
                if (countryState?.country === "") {
                    setCountryState((prv) => ({ ...prv, countryError: "Please select your country" }))
                }
                if (countryState?.state === "") {
                    setCountryState((prv) => ({ ...prv, stateError: "Please select your state" }))
                }
            }
        }

        function _handleInputChange(event) {
            const { name, value } = event.target;
            setFormData({ ...formData, [name]: value, });
        };

        function inCreaseStepper(data, callback) {
            if (data === "VALID") {
                // setActiveStep((prv) => prv + 1);
                if (activeStep === 0 && process?.env?.NEXT_PUBLIC_COMING_SOON === 'true') {
                    setActiveStep((prv) => prv + 2);
                } else {
                    setActiveStep((prv) => prv + 1);
                }
            } else {
                if (activeStep === 0 && process?.env?.NEXT_PUBLIC_COMING_SOON === 'true') {
                    setActiveStep((prv) => prv + 2);
                } else {
                    setActiveStep((prv) => prv + 1);
                }
            }
        };

        // google option selections 
        function _handelGooglePlace(results, fieldValue) {
            if (results) {
                _googleAddressSetup(results, (ADDRESS) => {
                    setFormData({
                        ...fieldValue?.values,
                        address: ADDRESS?.shipping_street,
                        zipcode: ADDRESS?.shipping_zipcode,
                        city: ADDRESS?.shipping_city,
                    });
                    setCountryState((prv) => ({
                        ...prv, state: ADDRESS?.shipping_state,
                        country: ADDRESS?.shipping_country
                    }));
                    fieldValue?.setFieldValue('shipping_state', ADDRESS?.shipping_state);
                    fieldValue?.setFieldValue('shipping_country', ADDRESS?.shipping_country);
                })
            }
        }

        function _checkPhoneNumber(data, actions, callback = null) {
            let isUserLogin = localStorageCall().getItem('Token');
            try {
                dispatch(getCustomerRefferal((res) => {
                    if (res?.length > 0) {
                        if (res?.[0]?.customerId === isUserLogin) {
                            if (callback) callback();
                        } else {
                            if (actions) {
                                actions?.setFieldError('phone', 'Phone number already exists.');
                                actions.setSubmitting(false);
                                _scrollToUp();
                            }
                        }
                    } else {
                        if (callback) callback();
                    }
                }, data?.phone, 'phoneNumber'));
            } catch (er) {
                console.log(er)
            }
        }

        function _emailValidate(data, callback, actions = null) {
            dispatch(getAllCustomerData((userDatas) => {
                if (_.find(userDatas, ({ userName }) => _.lowerCase(data?.email) === _.lowerCase(userName))) {
                    setEmailExistError("E-mail is already exist");
                    _scrollToUp();
                    setTimeout(() => setEmailExistError(''), 10000)
                } else {
                    _checkPhoneNumber(data, actions, () => {
                        setEmailExistError('');
                        callback();
                    });
                    // try {
                    //     dispatch(getCustomerRefferal((res) => {
                    //         if (res?.length > 0) {
                    //             if (res?.[0]?.customerId === isUserLogin) {
                    //                 setEmailExistError('');
                    //                 callback();
                    //             } else {
                    //                 if (actions) {
                    //                     actions?.setFieldError('phone', 'Phone number already exists.');
                    //                     actions.setSubmitting(false);
                    //                     _scrollToUp();
                    //                 }
                    //             }
                    //         } else {
                    //             setEmailExistError('');
                    //             callback();
                    //         }
                    //     }, data?.phone, 'phoneNumber'));
                    // } catch (er) {
                    //     console.log(er)
                    // }
                }
            }, null, data?.email));
        }

        function _validateRefferalFunction(refferal, callback) {
            dispatch(getCustomerRefferal((data) => {
                if (data?.length === 0) {
                    setWebAliesErros((prv) => ({ ...prv, isRefferalError: "Referral code is not found", isRefferalValid: false, isRefferalId: null }));
                    _setTimeOut(() => setWebAliesErros((prv) => ({ ...prv, isRefferalError: "" })), 1500);
                    callback(false);
                    return;
                } else {
                    setWebAliesErros({ changeRefferal: false, isRefferalError: '', isRefferalValid: true, isRefferalId: data[0]?.customerId });
                    const refferalData = JSON.stringify({ "id": data[0]?.customerId, "name": data[0]?.fullName, "webalies": data[0]?.webAlias });
                    localStorageCall().setItem('refferal_link', refferalData);
                    callback(true);
                }
            }, refferal));
        };

        function _webAliesCheckDuringSubmit(currentWebAlias, callback, section='') {
            // if (currentWebAlias !== formData?.webAlias) {
            dispatch(getCustomerRefferal((data) => {
                if (data?.length > 0) {
                    setWebAliesErros((prv) => ({ ...prv, isWebAliesError: "This Web Alias is already used." }));
                    if(section!=='webalias_check'){
                      _setTimeOut(() => setWebAliesErros((prv) => ({ ...prv, isWebAliesError: "" })), 10000);
                    }
                    return;
                } else {
                    callback();
                    if(section==='webalias_check'){
                        setWebAliesErros((prv) => ({ ...prv, isWebAliesError: "" }));
                      }
                }
            }, currentWebAlias, "urlRef"));
            // } else {
            //     callback();
            // }
        }

        function _handleOtpValidate(callback) {
            if (otp?.join('') === '121212') {
                setActiveStep(activeStep + 1);
                callback(false)
            } else {
                callback(true);
            }
        }

        const handleChangeValidate = (element, index) => {
            if (isNaN(element.value)) return false;
            setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);
            if (element.nextSibling) {
                element.nextSibling.focus();
            }
        };

        function _updateDataOfUser() {
            if (userData?.emailAddress) {
                const DEFAULT_DETAIL = _IBOformDefaultFormat(userData, formData, countryState);
                setFormData({ ...DEFAULT_DETAIL, termscondition: true, policyProcedures: true });
                setCountryState((prv) => ({
                    country: prv?.shipping_country || userData?.countryCode,
                    state: prv?.shipping_state || userData?.shippingAddress?.regionProvState
                }));
            }
        }

        useEffect(() => {
            _updateDataOfUser();
        }, [userData?.emailAddress]);

        return <Component {...{
            formData, setFormData, countryState, setCountryState, webAliesError, setWebAliesErros, otp, emailExistError,
            _handleSetFormValues, inCreaseStepper, _webAliesCheckDuringSubmit, _validateRefferalFunction, _emailValidate,
            _handleOtpValidate, handleChangeValidate, _handleInputChange, Dates, _checkPhoneNumber, _handelGooglePlace
        }} {...props} />
    }

    return ComponentWithFormProp;

}

export default withFormHOC;